import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { Utils } from 'src/app/core/utils';
import { TranslateService } from '@ngx-translate/core';
import { TypeofExpr } from '@angular/compiler';
import { ConfirmeAppointmentTypes } from 'src/app/core/enums';


@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss']
})
export class AppointmentComponent implements OnInit {

  @Input() appointment: AppointmentModel;
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() confirmed: EventEmitter<any> = new EventEmitter();
  @Output() paid: EventEmitter<any> = new EventEmitter();
  @Output() captureFile: EventEmitter<any> = new EventEmitter();
  @Output() uploadDocument: EventEmitter<any> = new EventEmitter();
  @Output() paymentRequest: EventEmitter<any> = new EventEmitter();
  @Output() sendOrFillForm: EventEmitter<any> = new EventEmitter();

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  onDelete(appointment) {
    this.delete.emit(appointment);
  }

  onConfirm(appointment) {
    
    this.confirmed.emit(appointment);
  }

  onPaid(appointment) {    
    this.paid.emit(appointment);
  }

  visitReasonSummary() {
    return Utils.generateVisitReasonSummary1(this.appointment.Treatments, this.translate);
  }

  public get confirmeAppointmentType() : typeof ConfirmeAppointmentTypes{
    return ConfirmeAppointmentTypes;
  }

  onCaptureImageClick(appointment){
    this.captureFile.emit(appointment);
  }

  onUploadDocumentClick(appointment){
    this.uploadDocument.emit(appointment);
  }

  onPaymentRequest(data:any){        
    this.paymentRequest.emit(data);
  }

  onSendOrFillForm(data:any){    
    this.sendOrFillForm.emit(data);
  }

}
